import React, { type ReactElement, useMemo } from 'react'
import { css, type SerializedStyles } from '@emotion/react'
import {
  gridBodyCellStyles,
  gridSortableCellStyles,
  gridSortedCellStyles,
} from '../utils/grid.styles'
import { type GridDatum, type GridCell } from '../utils/grid.types'

interface Props<TDatum extends GridDatum> extends GridCell<TDatum> {}

export const GridBodyCell = <TDatum extends GridDatum>({
  getCellProps,
  render,
  column,
}: Props<TDatum>): ReactElement => {
  const renderedCell = useMemo(() => render('Cell'), [render])
  const { style, ...cellProps } = getCellProps()
  const dynamicStyles = css(
    style as SerializedStyles,
    gridBodyCellStyles,
    column.canSort && gridSortableCellStyles,
    column.isSorted && gridSortedCellStyles,
    column.cellStyles && column.cellStyles
  )

  return (
    <div {...cellProps} css={dynamicStyles}>
      {renderedCell}
    </div>
  )
}
